import * as Api from '@utils/Api';
import { call, put } from 'redux-saga/effects';
import { types as billingTypes } from '@reducers/billing';

export function* fetchBillingInfo(action) {
  const { organizationUUID } = action;
  if (!organizationUUID) {
    throw new Error('Missing required parameters for billing information.');
  }

  const response = yield call(
    Api.get,
    `organizations/${organizationUUID}/billing-info`
  );
  const data = response.data;
  if (!response.success) {
    yield put({
      type: billingTypes.GET_BILLING_INFO_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
      errorCode: response.status,
    });
  } else {
    yield put({
      type: billingTypes.GET_BILLING_INFO_SUCCESS,
      uuid: organizationUUID,
      billing: data,
    });
  }
}

export function* updateInvoiceContactInfo(action) {
  const { organizationUUID, name, email, memo } = action;
  if (!organizationUUID || !name || !email) {
    throw new Error(
      'Missing required parameters for invoice contact information.'
    );
  }

  const response = yield call(
    Api.put,
    `organizations/${organizationUUID}/invoices/contact`,
    { name, email, memo }
  );

  if (!response.success) {
    yield put({
      type: billingTypes.UPDATE_INVOICE_CONTACT_FAILURE,
      error: response.data?.error_message || 'Unknown Error',
      errorCode: response.status,
    });
  } else {
    yield put({
      type: billingTypes.UPDATE_INVOICE_CONTACT_SUCCESS,
    });
    yield put({
      type: billingTypes.GET_BILLING_INFO_REQUEST,
      organizationUUID,
    });
  }
}
